import { extendTheme } from "@chakra-ui/react";
import components from "./components";
import "intl-tel-input/build/css/intlTelInput.css";

const theme = extendTheme({
  styles: {
    global: (theme: any) => ({
      html: { "--header-height": "76px", "--sidebar-width": "320px", fontSize: "14px" },
      body: { bgColor: "gray.50" },
      ".iti": { width: "100%", display: "inline-flex" },
      ".iti--allow-dropdown .iti__flag-container": {
        insetEnd: "auto",
        insetStart: 0,
      },
      ".iti--allow-dropdown input[type=tel]": {
        direction: "ltr",
        textAlign: "right",
        pr: 10,
        pl: 4,
      },
      ".iti__selected-flag": {
        borderStartRadius: 2.5,
      },
      ".iti__arrow": { display: "none" },
      ".iti__country-list": {
        textAlign: "right",
        direction: "ltr",
      },
      ".iti-mobile .iti--container": {
        zIndex: 9999,
        insetStart: "10px",
        width: "calc(100% - 20px)",
      },
    }),
  },
  components,
  direction: "rtl",
  fonts: {
    heading: "Droid Arabic Kufi, sans-serif",
    body: "Droid Arabic Kufi, sans-serif",
  },
  shadows: {
    sm: "0px 0px 1px rgba(48, 49, 51, 0.05),0px 2px 4px rgba(48, 49, 51, 0.1)",
    md: "rgb(112 144 176 / 18%) 0px 0px 8px 1px",
  },
});

export default theme;
